import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.Double
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface PlaceSortControllerTargetLifecycleHooks {
  public fun listTargetConnected(element: HTMLElement) {
  }

  public fun listTargetDisconnected(element: HTMLElement) {
  }

  public fun itemTargetConnected(element: HTMLElement) {
  }

  public fun itemTargetDisconnected(element: HTMLElement) {
  }

  public fun showMoreTargetConnected(element: HTMLElement) {
  }

  public fun showMoreTargetDisconnected(element: HTMLElement) {
  }

  public fun typeButtonTargetConnected(element: HTMLElement) {
  }

  public fun typeButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun openNowButtonTargetConnected(element: HTMLElement) {
  }

  public fun openNowButtonTargetDisconnected(element: HTMLElement) {
  }

  public fun searchInputTargetConnected(element: HTMLElement) {
  }

  public fun searchInputTargetDisconnected(element: HTMLElement) {
  }

  public fun limitValueChanged(`value`: Double, previousValue: Double) {
  }

  public fun expandedValueChanged(`value`: Boolean, previousValue: Boolean) {
  }
}

public fun <T : HTMLElement> PlaceSortController.listTarget(): StimulusProperty<T> =
    StimulusProperty("listTarget")

public fun <T : HTMLElement> PlaceSortController.listTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("listTargets")

public fun <T : HTMLElement> PlaceSortController.itemTarget(): StimulusProperty<T> =
    StimulusProperty("itemTarget")

public fun <T : HTMLElement> PlaceSortController.itemTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("itemTargets")

public fun <T : HTMLElement> PlaceSortController.showMoreTarget(): StimulusProperty<T> =
    StimulusProperty("showMoreTarget")

public fun <T : HTMLElement> PlaceSortController.showMoreTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("showMoreTargets")

public fun <T : HTMLElement> PlaceSortController.typeButtonTarget(): StimulusProperty<T> =
    StimulusProperty("typeButtonTarget")

public fun <T : HTMLElement> PlaceSortController.typeButtonTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("typeButtonTargets")

public fun <T : HTMLElement> PlaceSortController.openNowButtonTarget(): StimulusProperty<T> =
    StimulusProperty("openNowButtonTarget")

public fun <T : HTMLElement> PlaceSortController.openNowButtonTargets(): StimulusProperty<Array<T>>
    = StimulusProperty("openNowButtonTargets")

public fun <T : HTMLElement> PlaceSortController.searchInputTarget(): StimulusProperty<T> =
    StimulusProperty("searchInputTarget")

public fun <T : HTMLElement> PlaceSortController.searchInputTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("searchInputTargets")

public fun PlaceSortController.limitValue(): StimulusProperty<Double> =
    StimulusProperty("limitValue")

public fun PlaceSortController.hasLimitValue(): Boolean {
  println(this.asDynamic()["hasLimitValue"])
  return this.asDynamic()["hasLimitValue"]
}

public fun PlaceSortController.expandedValue(): StimulusProperty<Boolean> =
    StimulusProperty("expandedValue")

public fun PlaceSortController.hasExpandedValue(): Boolean {
  println(this.asDynamic()["hasExpandedValue"])
  return this.asDynamic()["hasExpandedValue"]
}

public fun registerPlaceSortController(stimulus: Application) {
               val clazz = PlaceSortController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "list",
  "item",
  "showMore",
  "typeButton",
  "openNowButton",
  "searchInput",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("limit", "Number", false),
  ValueDefinition("expanded", "Boolean", false)
                      ),
                      PlaceSortController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "placesort"
              println("Registering controller placesort")

              stimulus.register(controllerName, factoryFunc)
}
